/** Components  **/

/** Dropdown Accordion **/
document.addEventListener("DOMContentLoaded", () => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function open(content, chev) {
    // Start from 0 -> target px; after transition, release to 'none'
    content.classList.add("is-open");
    const target = content.scrollHeight;
    content.style.maxHeight = target + "px";

    if (!reduceMotion) {
      const onEnd = (e) => {
        if (e.propertyName === "max-height") {
          content.style.maxHeight = "none";
          content.removeEventListener("transitionend", onEnd);
        }
      };
      content.addEventListener("transitionend", onEnd);
    } else {
      content.style.maxHeight = "none";
    }
    chev?.classList.add("rotate-180");
  }

  function close(content, chev) {
    // From 'none' or open state -> lock current px -> 0
    const current = content.getBoundingClientRect().height;
    content.style.maxHeight = current + "px";
    // force reflow
    content.offsetHeight;
    content.style.maxHeight = "0px";
    content.classList.remove("is-open");
    chev?.classList.remove("rotate-180");
  }

  // Set initial state based on aria-expanded
  document.querySelectorAll(".product-accordion").forEach((acc) => {
    const btn = acc.querySelector(".js-accordion-toggle");
    const panel = acc.querySelector(".product-accordion-content");
    const chev = btn?.querySelector(".chev");
    const expanded = btn?.getAttribute("aria-expanded") === "true";
    if (expanded) {
      panel.classList.add("is-open");
      panel.style.maxHeight = "none";
      chev?.classList.add("rotate-180");
    } else {
      panel.style.maxHeight = "0px";
    }
  });

  // Toggle
  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest(".js-accordion-toggle");
    if (!btn) return;
    const acc = btn.closest(".product-accordion");
    const panel = acc.querySelector(".product-accordion-content");
    const chev = btn.querySelector(".chev");

    const expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", String(!expanded));

    if (!expanded) {
      if (getComputedStyle(panel).maxHeight === "none") panel.style.maxHeight = "0px";
      open(panel, chev);
    } else {
      close(panel, chev);
    }
  });

  // Keep open panels sized on resize
  window.addEventListener("resize", () => {
    document.querySelectorAll(".product-accordion-content.is-open").forEach((panel) => {
      if (getComputedStyle(panel).maxHeight !== "none") return;
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.offsetHeight;
      panel.style.maxHeight = "none";
    });
  });
});
